import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTextField } from 'vuetify/lib/components/VTextField';
import ClickOutside from 'vuetify/lib/directives/click-outside';

import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "content-centered large"
  }, [_c("h1", [_vm._v("Credit Notes")]), _c("div", {
    staticClass: "search-global-container"
  }, [_c("div", {
    staticClass: "search-top-buttons"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      rounded: true
    },
    on: {
      click: function click($event) {
        return _vm.openCreditNoteModal();
      }
    }
  }, [_c(VIcon, {
    attrs: {
      dark: ""
    }
  }, [_vm._v("mdi-plus")]), _vm._v(" new credit note ")], 1)], 1), _c("div", {
    staticClass: "search-main-line"
  }, [_c("div", {
    staticClass: "search-main-text-field"
  }, [_c(VTextField, {
    attrs: {
      solo: "",
      "hide-details": "auto",
      placeholder: "Search for a customer, number, description",
      "append-icon": "fa-search",
      clearable: ""
    },
    on: {
      "click:append": function clickAppend($event) {
        return _vm.search(true);
      },
      keydown: function keydown($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.search(true);
      },
      "click:clear": function clickClear() {
        _vm.formSearch.label = null;
        _vm.search(true);
      }
    },
    model: {
      value: _vm.formSearch.label,
      callback: function callback($$v) {
        _vm.$set(_vm.formSearch, "label", $$v);
      },
      expression: "formSearch.label"
    }
  })], 1), _c("div", {
    staticClass: "search-pagination-limit"
  }, [_c(VSelect, {
    staticClass: "paging-limits-select",
    attrs: {
      solo: "",
      "hide-details": "auto",
      items: _vm.pagingLimitsChoices
    },
    on: {
      change: function change($event) {
        return _vm.search(true);
      }
    },
    model: {
      value: _vm.formSearch.paging.limits,
      callback: function callback($$v) {
        _vm.$set(_vm.formSearch.paging, "limits", $$v);
      },
      expression: "formSearch.paging.limits"
    }
  })], 1)]), _c("div", {
    staticClass: "search-table-top"
  }, [_c("div", {
    staticClass: "search-other-fields"
  }, [_c("div", [_c(VSelect, {
    attrs: {
      solo: "",
      items: _vm.creditNoteStatus,
      "item-value": "value",
      "item-text": "label",
      label: "Filter by status",
      clearable: "",
      "hide-details": "auto"
    },
    on: {
      change: function change($event) {
        return _vm.search(true);
      },
      "click:clear": function clickClear() {
        _vm.formSearch.status = null;
        _vm.search(true);
      }
    },
    model: {
      value: _vm.formSearch.status,
      callback: function callback($$v) {
        _vm.$set(_vm.formSearch, "status", $$v);
      },
      expression: "formSearch.status"
    }
  })], 1), _c("div", [_c(VCheckbox, {
    staticStyle: {
      width: "fit-content"
    },
    attrs: {
      "hide-details": "auto",
      label: "Include deleted credit notes"
    },
    on: {
      change: function change($event) {
        return _vm.search(true);
      }
    },
    model: {
      value: _vm.formSearch.includeDeleted,
      callback: function callback($$v) {
        _vm.$set(_vm.formSearch, "includeDeleted", $$v);
      },
      expression: "formSearch.includeDeleted"
    }
  })], 1)]), _c("div", {
    staticClass: "search-pagination-index"
  }, [_c("Index", {
    attrs: {
      currentPage: +_vm.formSearch.paging.currentPage,
      limits: +_vm.formSearch.paging.limits,
      totalNumber: _vm.creditNoteCount
    }
  })], 1)])]), _c("div", {
    staticClass: "list-container"
  }, [_c(VDataTable, {
    staticClass: "elevation-2 cursor--pointer",
    attrs: {
      headers: _vm.headers,
      items: _vm.items,
      "items-per-page": +_vm.formSearch.paging.limits,
      loading: _vm.isLoading,
      "loading-text": "Loading... Please wait",
      "hide-default-footer": "",
      "disable-sort": ""
    },
    on: {
      "click:row": _vm.selectItem
    },
    scopedSlots: _vm._u([{
      key: "item.status",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [item.status === _vm.creditNote.status.DRAFT && !item.deleted ? _c("div", {
          staticClass: "badge warning"
        }, [_vm._v(" Draft ")]) : item.status === _vm.creditNote.status.VALIDATED && !item.deleted ? _c("div", {
          staticClass: "badge neutral"
        }, [_vm._v(" Validated ")]) : item.status === _vm.creditNote.status.CLOSED && !item.deleted ? _c("div", {
          staticClass: "badge success"
        }, [_vm._v(" Closed ")]) : _c("div", {
          staticClass: "badge danger"
        }, [_vm._v("Deleted")])];
      }
    }, {
      key: "item.issuingImporterRefs",
      fn: function fn(_ref2) {
        var _item$issuingImporter;
        var item = _ref2.item;
        return [((_item$issuingImporter = item.issuingImporter) === null || _item$issuingImporter === void 0 ? void 0 : _item$issuingImporter.id) > 0 ? [_c("div", [_vm._v(" " + _vm._s(item.issuingImporterNumberLabel) + " ")]), _c("div", {
          staticClass: "text-smaller text-italic"
        }, [_vm._v(" " + _vm._s(item.issuingImporter.name) + " ")])] : _vm._e()];
      }
    }, {
      key: "item.extraDescription",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [_c("span", {
          staticClass: "text-smaller"
        }, [_vm._v(" " + _vm._s(item.extraDescription) + " ")])];
      }
    }, {
      key: "item.origin",
      fn: function fn(_ref4) {
        var _item$fromOrder, _item$fromOrder2, _item$fromOrder3, _item$fromOrder4, _item$fromOrder5;
        var item = _ref4.item;
        return [(_item$fromOrder = item.fromOrder) !== null && _item$fromOrder !== void 0 && _item$fromOrder.invoiceNumberLabel ? [_c("div", [_vm._v(_vm._s((_item$fromOrder2 = item.fromOrder) === null || _item$fromOrder2 === void 0 ? void 0 : _item$fromOrder2.invoiceNumberLabel))]), (_item$fromOrder3 = item.fromOrder) !== null && _item$fromOrder3 !== void 0 && _item$fromOrder3.importerInvoiceNumberLabel ? _c("div", {
          staticClass: "text-smaller"
        }, [_vm._v(" " + _vm._s(item.fromOrder.importerInvoiceNumberLabel) + " ")]) : _vm._e()] : (_item$fromOrder4 = item.fromOrder) !== null && _item$fromOrder4 !== void 0 && _item$fromOrder4.importerInvoiceNumberLabel ? [_c("div", [_vm._v(" " + _vm._s(item.fromOrder.importerInvoiceNumberLabel) + " ")])] : _vm._e(), (_item$fromOrder5 = item.fromOrder) !== null && _item$fromOrder5 !== void 0 && _item$fromOrder5.referenceOrder ? _c("div", {
          staticClass: "text-smaller text-italic"
        }, [_vm._v(" " + _vm._s(item.fromOrder.referenceOrder.shorterReference()) + " ")]) : _vm._e()];
      }
    }, {
      key: "item.totalAmountCurrency",
      fn: function fn(_ref5) {
        var item = _ref5.item;
        return [_vm._v(" " + _vm._s(_vm.formatPrice(item.totalAmountCurrency)) + " " + _vm._s(_vm.getSymbolCurrency(item.initialCurrency)) + " ")];
      }
    }, {
      key: "item.remaining.amountCurrency",
      fn: function fn(_ref6) {
        var item = _ref6.item;
        return [_vm._v(" " + _vm._s(_vm.formatPrice(item.remaining.amountCurrency)) + " " + _vm._s(_vm.getSymbolCurrency(item.initialCurrency)) + " ")];
      }
    }, {
      key: "item.comment",
      fn: function fn(_ref7) {
        var item = _ref7.item;
        return [_c("span", {
          staticClass: "text-smaller"
        }, [_vm._v(" " + _vm._s(item.comment) + " ")])];
      }
    }], null, true)
  })], 1), _vm.hasResult ? _c("div", {
    staticClass: "table-bottom-container"
  }, [_c("div", {
    staticClass: "table-bottom-pagination-paging"
  }, [_c("Paging", {
    attrs: {
      numberOfPages: _vm.numberOfPages,
      currentPage: +_vm.formSearch.paging.currentPage
    },
    on: {
      changePage: _vm.changePage
    }
  })], 1), _c("div", {
    staticClass: "table-bottom-right"
  }, [_c("div", {
    staticClass: "table-bottom-pagination-limit"
  }, [_c(VSelect, {
    attrs: {
      items: _vm.pagingLimitsChoices,
      solo: "",
      "hide-details": "auto"
    },
    on: {
      change: _vm.search
    },
    model: {
      value: _vm.formSearch.paging.limits,
      callback: function callback($$v) {
        _vm.$set(_vm.formSearch.paging, "limits", $$v);
      },
      expression: "formSearch.paging.limits"
    }
  })], 1), _c("div", {
    staticClass: "table-bottom-pagination-index"
  }, [_c("Index", {
    attrs: {
      currentPage: +_vm.formSearch.paging.currentPage,
      limits: +_vm.formSearch.paging.limits,
      totalNumber: _vm.creditNoteCount
    }
  })], 1)])]) : _vm._e(), _c(VNavigationDrawer, {
    directives: [{
      def: ClickOutside,
      name: "click-outside",
      rawName: "v-click-outside",
      value: _vm.clickOutsideDrawer,
      expression: "clickOutsideDrawer"
    }],
    attrs: {
      fixed: "",
      bottom: "",
      right: "",
      width: "40%",
      temporary: ""
    },
    on: {
      input: _vm.changeDrawer
    },
    model: {
      value: _vm.drawer,
      callback: function callback($$v) {
        _vm.drawer = $$v;
      },
      expression: "drawer"
    }
  }, [_c("div", {
    staticClass: "drawer"
  }, [_c("section", {
    staticClass: "drawer-header"
  }, [_c("h2", {
    staticClass: "drawer-title"
  }, [_vm._v(_vm._s(_vm.currentItem.numberLabel))]), _c("div", {
    staticClass: "drawer-header-button"
  }, [_c("div", {
    staticClass: "flex justify-end mb-3 gap-2"
  }, [_vm.currentItem.status !== _vm.creditNote.status.DRAFT ? _c(VBtn, {
    staticClass: "dfwa-btn secondary --small-2",
    attrs: {
      loading: _vm.isFetchingCNFile,
      disabled: _vm.isDisabledCNFile,
      title: "Download PDF"
    },
    on: {
      click: function click($event) {
        return _vm.openUrl(_vm.currentItem.url);
      }
    }
  }, [_c(VIcon, {
    staticClass: "mr-1",
    attrs: {
      size: "0.65rem"
    }
  }, [_vm._v("mdi-file-download-outline")]), _vm._v(" PDF ")], 1) : _vm._e(), !_vm.currentItem.deleted && _vm.currentItem.status == _vm.creditNote.status.VALIDATED ? _c(VBtn, {
    staticClass: "dfwa-btn secondary --small-2",
    attrs: {
      disabled: _vm.currentItem.remaining.amountCurrency <= 0,
      title: "Refund credit note"
    },
    on: {
      click: function click($event) {
        return _vm.showCreditNoteRefundDialog(true);
      }
    }
  }, [_c(VIcon, {
    staticClass: "mr-1",
    attrs: {
      size: "0.65rem"
    }
  }, [_vm._v("mdi-cash-refund")]), _vm._v(" Refund ")], 1) : _vm._e(), !_vm.currentItem.deleted && _vm.currentItem.status === _vm.creditNote.status.DRAFT && !_vm.isInUsed(_vm.currentItem) ? _c(VBtn, {
    staticClass: "dfwa-btn secondary --small-2",
    attrs: {
      loading: _vm.isFetchingOrder,
      title: "Edit"
    },
    on: {
      click: function click($event) {
        return _vm.openCreditNoteModal(false);
      }
    }
  }, [_c(VIcon, {
    staticClass: "mr-1",
    attrs: {
      size: "0.65rem"
    }
  }, [_vm._v("mdi-pencil")]), _vm._v(" Edit ")], 1) : !_vm.currentItem.deleted ? _c(VBtn, {
    staticClass: "dfwa-btn secondary --small-2",
    attrs: {
      title: "See"
    },
    on: {
      click: function click($event) {
        return _vm.getToEditCreditNote(_vm.currentItem);
      }
    }
  }, [_c(VIcon, {
    staticClass: "mr-1",
    attrs: {
      size: "0.65rem"
    }
  }, [_vm._v("mdi-text-box-search-outline")]), _vm._v(" Details ")], 1) : _vm._e(), !_vm.currentItem.deleted && _vm.currentItem.status !== _vm.creditNote.status.CLOSED ? _c(VBtn, {
    staticClass: "dfwa-btn secondary --small-2",
    attrs: {
      title: _vm.currentItem.status === _vm.creditNote.status.DRAFT ? "Delete" : "Cancel",
      disabled: _vm.isInUsed(_vm.currentItem)
    },
    on: {
      click: _vm.deleteCreditNote
    }
  }, [_c(VIcon, {
    staticClass: "mr-1",
    attrs: {
      size: "0.65rem"
    }
  }, [_vm._v("mdi-delete")]), _vm._v(" " + _vm._s(_vm.creditNote.status.DRAFT ? "Delete" : "Cancel") + " ")], 1) : _vm._e()], 1)])]), _vm.isInUsed(_vm.currentItem) ? _c("section", {
    staticClass: "drawer-message"
  }, _vm._l(_vm.currentItem.uses, function (use) {
    return _c("div", {
      key: use.id
    }, [_vm._v(" Used on (" + _vm._s(use.order.referenceOrder ? use.order.referenceOrder.shorterReference() : use.refundingNote) + ") ")]);
  }), 0) : _vm._e(), _c("section", {
    staticClass: "drawer-section"
  }, [_c("div", {
    staticClass: "drawer-section-title"
  }, [_vm._v(" Attached files "), _c(VBtn, {
    staticClass: "dfwa-btn --small-2 secondary",
    on: {
      click: function click($event) {
        return _vm.openTagsDialog();
      }
    }
  }, [_c(VIcon, {
    staticClass: "fas fa-tag mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Manage tags ")], 1)], 1), _vm.isLoadingFiles ? _c(VSkeletonLoader, {
    attrs: {
      "max-height": "5rem",
      type: "image"
    }
  }) : [_c("div", {
    staticClass: "drawer-file-list"
  }, [!_vm.currentItem.files.length ? _c("p", {
    staticClass: "flex text-sm text-center"
  }, [_vm._v("No files yet")]) : _vm._e(), _vm._l(_vm.currentItem.files, function (file) {
    return _c("div", {
      key: file.id,
      staticClass: "global-file-chip"
    }, [_c("div", {
      staticClass: "tag"
    }, [file.tag ? _c(VChip, {
      staticClass: "drawer-file-chip tag",
      attrs: {
        label: "",
        close: "",
        "close-icon": "mdi-close-thick"
      },
      on: {
        "click:close": function clickClose($event) {
          return _vm.removeTagFromDocument(file.id);
        }
      }
    }, [_c(VIcon, {
      staticClass: "tag-icon",
      attrs: {
        left: "",
        small: ""
      }
    }, [_vm._v("mdi-tag")]), _c("b", [_vm._v(_vm._s(file.tag.name))])], 1) : _c(VChip, {
      staticClass: "drawer-file-chip tag",
      attrs: {
        label: ""
      },
      on: {
        click: function click($event) {
          return _vm.openAddTagToDocument(file.id);
        }
      }
    }, [_c(VIcon, {
      staticClass: "tag-icon",
      attrs: {
        left: "",
        small: ""
      }
    }, [_vm._v("mdi-tag")]), _c("p", {
      staticClass: "font-italic ma-0"
    }, [_vm._v("Add tag")]), _c(VIcon, {
      attrs: {
        right: ""
      }
    }, [_vm._v("mdi-plus-thick")])], 1)], 1), _c(VChip, {
      staticClass: "drawer-file-chip",
      attrs: {
        close: "",
        label: ""
      },
      on: {
        click: function click($event) {
          return _vm.openUrl(file.url);
        },
        "click:close": function clickClose($event) {
          return _vm.removeFile(file.id);
        }
      }
    }, [_c(VIcon, {
      attrs: {
        left: ""
      }
    }, [_vm._v("mdi-cloud-download")]), _vm._v(" " + _vm._s(file.filename) + " ")], 1)], 1);
  })], 2)], _c("UploaderV2", {
    key: +_vm.drawer,
    attrs: {
      canClear: "",
      url: _vm.uploadUrl,
      fileTypes: [".xlsx", ".xlsm", ".jpg", ".png", ".gif", ".pdf"],
      label: "Attach File(s) to Credit Note"
    },
    on: {
      "click:upload": _vm.upload
    }
  })], 2)]), _c("ManageDocumentsTagsDialog", {
    ref: "ManageDocumentsTagsDialog",
    on: {
      tagListChanged: function tagListChanged($event) {
        return _vm.tagListChangedUpdate();
      }
    }
  }), _c("AddTagToDocumentDialog", {
    ref: "AddTagToDocumentDialog",
    on: {
      tagAddedToDocument: function tagAddedToDocument($event) {
        return _vm.tagListChangedUpdate();
      },
      openManageTagsDialog: function openManageTagsDialog($event) {
        return _vm.openTagsDialog();
      }
    }
  }), _c("Confirm", {
    ref: "confirmDocumentDrawer"
  })], 1), _c("Confirm", {
    ref: "confirm"
  }), _vm.creditNoteDialogRefundShown ? _c("CreditNoteRefundDialog", {
    ref: "CreditNoteRefundDialog",
    attrs: {
      dialog: _vm.creditNoteDialogRefundShown,
      creditNote: _vm.currentItem,
      confirm: _vm.addRefund,
      cancel: function cancel() {
        return _vm.showCreditNoteRefundDialog(false);
      }
    }
  }) : _vm._e(), _vm.creditNoteModalShown ? _c("CreditNoteModal", {
    ref: "CreditNoteModal",
    attrs: {
      order: _vm.order,
      "with-order": !!(_vm.currentItem.fromOrder && _vm.currentItem.fromOrder.id),
      "credit-note-id": _vm.currentItem.id
    },
    on: {
      closed: _vm.closeCreditNoteModal,
      closedandreloaded: _vm.closeAndReloadCreditNoteModal,
      validateandautoapply: _vm.closeAndReloadCreditNoteModal
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };